import React from "react";
import { useSelector } from "react-redux";

const CourseBuilderFooter = ({
  next,
  prev,
  current,
  validate,
  Submit,
  formValues,
  location,
  storedSession,
  quizCreation,
  quizSubmitHanlder,
  coursebuilderToggle,
  courseStatus,
}) => {
  const { isExperienced } = useSelector((state) => state?.users?.user);
  const submitCallBack = () => {
    if (formValues.scheduleEvent === "event" && current === 14) {
      Submit(2);
      return;
    } else if (current === 20) {
      Submit(2);
      return;
    } else if (current === 22) {
      Submit(2);
      return;
    } else if (courseStatus === "createBundle" && current === 16) {
      Submit(2);
      return;
    }
    next();
  };

  const createDraftCallback = () => {
    if (!location.state) {
      Submit(1, true);
    }
  };

  const isCreateCourse = (current, location) => {
    if (storedSession === "liveCourse") {
      return current === 8 && !location.state;
    } else if (storedSession === "onDemand") {
      return current === 7 && !location.state;
    } else if (courseStatus === "createBundle") {
      return current === 7 && !location.state;
    }
  };

  const StepNextStatus = () => {
    if (storedSession === "liveCourse" && current === 7) return 9;
    else if (storedSession === "liveCourse" && current === 8) return 9;
    else return 8;
  };

  const stepTextStatus = (current) => {
    if (storedSession === "liveCourse") {
      switch (current) {
        case 8:
          return "Start Process";
        case 7:
          return "NEXT";
      }
    }
    switch (current) {
      case 7:
        return "Start Process";
      case 14:
        return formValues.scheduleEvent === "event" ? "SUBMIT REVIEW" : "NEXT";
      case 16:
        return courseStatus === "createBundle" ? "Create Bundle" : "NEXT";
      case 20:
        return "SUBMIT REVIEW";
      case 22:
        return "SUBMIT REVIEW";
      default:
        return "NEXT";
    }
  };

  return (
    <>
      <div className="button-div">
        <div
          className={
            current < StepNextStatus()
              ? "button-course-container"
              : `${
                  coursebuilderToggle
                    ? "button-container"
                    : "button-container-1"
                } outline`
          }
        >
          {!courseStatus ? (
            isExperienced && current === 4 ? (
              <div></div>
            ) : !isExperienced && current === 0 ? (
              <div></div>
            ) : (
              <button
                type="button"
                className="btn mar-left-10 nextbutton upper"
                onClick={prev}
                disabled={isExperienced === true && current === 4}
              >
                Back
              </button>
            )
          ) : (
            <button
              type="button"
              className="btn mar-left-10 nextbutton upper"
              onClick={prev}
              disabled={current === 4}
            >
              Back
            </button>
          )}

          {current !== 21 && (
            <div className="mar-right-10">
              <button
                className={`btn mar-right-10 ${validate(current)} && next`}
                type="submit"
                onClick={
                  isCreateCourse(current, location)
                    ? createDraftCallback
                    : submitCallBack
                }
                disabled={!validate(current)}
              >
                {stepTextStatus(current)}
              </button>
            </div>
          )}

          {current === 21 && (
            <div className="mar-right-10">
              <button
                className={` btn mar-left-10 ${validate(current)} && next`}
                type="submit"
                onClick={quizSubmitHanlder}
                disabled={!validate(current)}
              >
                END QUIZ
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default CourseBuilderFooter;
